// vdb-setting-plp.js
// Custom filter logic for vdb-setting-plp.liquid (Moto theme)
// This script is scoped to the section using data-section-id

document.addEventListener('DOMContentLoaded', function () {
  // Find the section wrapper
  var section = document.querySelector('[data-section-type="collection-template"]');
  if (!section) return;

  // Drawer open/close
  section.querySelectorAll('.clair-filter-btn, .clair-all-filters').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var drawer = section.querySelector('#clairDrawer');
      if (drawer) drawer.classList.add('open');
    });
  });
  section.querySelectorAll('.clair-drawer-action--close').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var drawer = section.querySelector('#clairDrawer');
      if (drawer) drawer.classList.remove('open');
    });
  });

  // Accordion toggle
  section.querySelectorAll('.accordion-header.accordion-action-custom').forEach(function (header) {
    header.addEventListener('click', function () {
      var body = this.nextElementSibling;
      var isOpen = this.classList.contains('open');
      if (isOpen) {
        this.classList.remove('open');
        if (body) body.style.display = 'none';
      } else {
        this.classList.add('open');
        if (body) body.style.display = 'block';
      }
    });
  });

  // Filter form logic
  var filterForm = section.querySelector('#CollectionFilterForm');
  if (filterForm) {
    // On filter change (checkboxes, price, etc.)
    filterForm.addEventListener('change', function (e) {
      // If AJAX filtering is enabled, do AJAX, else submit
      var ajaxFiltering = section.getAttribute('data-ajax-filtering') === 'true';
      if (ajaxFiltering) {
        // AJAX filtering: fetch new product list and replace
        var url = section.getAttribute('data-filter-section-id')
          ? window.location.pathname + '?section_id=' + section.getAttribute('data-filter-section-id') + '&' + new URLSearchParams(new FormData(filterForm)).toString()
          : window.location.pathname + '?' + new URLSearchParams(new FormData(filterForm)).toString();
        fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (res) { return res.text(); })
          .then(function (html) {
            // Replace product list and filters
            var temp = document.createElement('div');
            temp.innerHTML = html;
            var newSection = temp.querySelector('[data-section-type="collection-template"]');
            if (newSection) {
              section.innerHTML = newSection.innerHTML;
              // Re-run this script to re-bind events
              setTimeout(function () { document.dispatchEvent(new Event('DOMContentLoaded')); }, 10);
            }
          });
      } else {
        // Non-AJAX: submit form (fallback)
        filterForm.submit();
      }
    });
  }

  // Sort select logic
  var sortSelect = section.querySelector('.clair-sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      // Add sort param and reload
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  // Apply/Reset buttons
  var applyBtn = section.querySelector('.apply-all-filters');
  if (applyBtn) {
    applyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (filterForm) {
        var event = new Event('change', { bubbles: true });
        filterForm.dispatchEvent(event);
      }
    });
  }
  var resetBtn = section.querySelector('.reset-all-filters');
  if (resetBtn) {
    resetBtn.addEventListener('click', function (e) {
      // Default resets to collection URL
      // No extra logic needed
    });
  }
});
